import { useRef, useLayoutEffect, RefObject } from 'react'

import { FetchMoreStatus } from '@/types'

export const useInfinityListObserver = (
  onFetchMore: () => void,
  observerRef: RefObject<Element>,
  fetchMoreStatus?: FetchMoreStatus,
) => {
  const observer = useRef<IntersectionObserver | null>(null)
  const callback = useRef<() => void>(onFetchMore)

  useLayoutEffect(() => {
    callback.current = onFetchMore
  }, [onFetchMore])

  useLayoutEffect(() => {
    if (observer.current) return undefined
    if (!observerRef.current) return undefined

    observer.current = new IntersectionObserver(
      entities => {
        if (entities.some(entity => entity.isIntersecting)) {
          callback.current?.()
        }
      },
      {
        threshold: 0.1,
      },
    )

    observer.current.observe(observerRef.current)

    return () => observer.current?.disconnect()
  }, [observerRef, fetchMoreStatus])
}
